import { createSlice } from "@reduxjs/toolkit";

export const themeSlice = createSlice({
    name: "theme",
    initialState: {},
    reducers: {
        closeSidebar: (state: any) => {
            state.value = { sidebarClosed: true };
        },
        openSidebar: (state: any) => {
            state.value = { sidebarClosed: false };
        }
    },
});

export const {
    closeSidebar,
    openSidebar
} = themeSlice.actions;

export default themeSlice.reducer;